/* tslint:disable */
/* eslint-disable */
/**
 * seller
 * アグリノート米市場 Seller API
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: mazhulin.d@water-cell.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 * [現物契約] 特別条件マスタ
 * @export
 * @interface SpotContractSpecialConditionRead
 */
export interface SpotContractSpecialConditionRead {
  /**
   * ID
   * @type {number}
   * @memberof SpotContractSpecialConditionRead
   */
  readonly id: number
  /**
   * レコードのバージョン番号
   * @type {number}
   * @memberof SpotContractSpecialConditionRead
   */
  readonly versionNumber: number
  /**
   * ステータス（true: 有効、false: 無効）
   * @type {boolean}
   * @memberof SpotContractSpecialConditionRead
   */
  isActive: boolean
  /**
   * 特別条件名
   * @type {string}
   * @memberof SpotContractSpecialConditionRead
   */
  name: string
  /**
   * 売るぞう表示テキスト
   * @type {string}
   * @memberof SpotContractSpecialConditionRead
   */
  displayText: string
}

export function SpotContractSpecialConditionReadFromJSON(json: any): SpotContractSpecialConditionRead {
  return SpotContractSpecialConditionReadFromJSONTyped(json, false)
}

export function SpotContractSpecialConditionReadFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SpotContractSpecialConditionRead {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    versionNumber: json['version_number'],
    isActive: json['is_active'],
    name: json['name'],
    displayText: json['display_text'],
  }
}

export function SpotContractSpecialConditionReadToJSON(value?: SpotContractSpecialConditionRead | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    is_active: value.isActive,
    name: value.name,
    display_text: value.displayText,
  }
}
